import { Component, EventEmitter, OnInit } from '@angular/core';
import { IStatisticFilters, IStatisticParams } from '@shared-libs/interfaces';

@Component({
	selector: 'loan-statistics-component',
	templateUrl: 'loan-statistics.component.html',
	styleUrls: ['./loan-statistics.component.scss'],
})
export class LoanStatisticsComponent implements OnInit {
	public filters: IStatisticFilters;
	public params: IStatisticParams;
	public readonly paramsChanged: EventEmitter<IStatisticParams> = new EventEmitter();

	public ngOnInit(): void {
		this.params = {};
		this.filters = {
			dateRange: { visible: false, name: 'DATE' },
			zipcode: { visible: false, name: 'ZIPCODE' },
			digibankTargetAudience: { visible: false, name: 'TARGET_AUDIENCE' },
			ageCategory: { visible: false, name: 'AGE_CATEGORY' },
			gender: { visible: false, name: 'GENDER' },
			ClientOriginId: { visible: false, name: 'CLIENT_ORIGIN' },
			devices: { visible: false, name: 'CLIENT_DEVICETYPE' },
			DeviceTypeId: { visible: false, name: 'DEVICETYPE' },
		};
	}
}
